import React from 'react';

import './home.scss';
// import { useAppSelector } from '../../redux/hooks';
// import { RootState } from '../../redux';
// import { fullName } from '../../utils/strings';

const Home = () => {
  // const session = useAppSelector((state: RootState) => state.session.auth);
  // const user = useAppSelector((state: RootState) => state.session.user);

  return (
    <section className='containerHome'>
      <div className='presentation'>
        {/* {!session && ( */}
        <p className='heading-dark bold'>Bine ați venit pe Sirar!</p>
        {/* )} */}
        {/* {session && (
          <p className='heading-dark bold'>
            Bun venit pe SIRAR{fullName(user) ? ', ' : ''} {'\n'}
            <span className='secondary-color'>{fullName(user)} !</span>
          </p>
        )} */}
        {/* <p className='heading-dark bold'>
            Ai 4 <span className='secondary-color'>notificari</span>
          </p> */}
      </div>

      {/* {!session && (
        <div className='more row'>
          <IoIosArrowRoundForward />
          <Link to={ROUTES.LOGIN}>
            <button className='bold small-light'>Autentificare</button>
          </Link>
        </div>
      )} */}

      {/* effects  */}
      <div className='dark-block'></div>
      <div className='secondary-block-big'></div>
      <div className='secondary-block-medium'></div>
      <div className='secondary-block-small'></div>
      <div className='accent-block-big'></div>
      <div className='accent-block-medium'></div>
      <div className='accent-block-small'></div>
    </section>
  );
};

export default Home;
